import * as React from "react";

import { cn } from "./utils";

function Textarea({ className, style, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "resize-none border-gray-200 hover:border-gray-300 placeholder:text-muted-foreground focus-visible:border-gray-300 focus-visible:ring-gray-300/60 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full border bg-white px-3 py-2 text-base transition-[color,box-shadow] outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm rounded-md",
        className,
      )}
      style={{ caretColor: 'currentColor', ...(style || {}) }}
      {...props}
    />
  );
}

export { Textarea };
